<template>
<layout-content>
  <template #toolbar>
    <section v-if="isAdmin || orgTypeId === 1" class="toolbar-btn">
      <el-button
        type="orange"
        icon="el-icon-plus"
        size="small"
        @click="onOpenEditor()"
      >新建{{editName}}</el-button>
    </section>
  </template>

  <template #body>
    <el-table
      ref="table"
      :data="list"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @selection-change="onSelectionChange"
      @row-click="onSelectOrg"
    >
      <el-table-column label="序号" width="50">
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column>

      <el-table-column prop="name" label="组织名称" />
      <el-table-column label="组织类型">
        <template slot-scope="{row}">{{orgTypeMap[row.typeId] ? orgTypeMap[row.typeId].name : ''}}</template>
      </el-table-column>
      <el-table-column prop="contactName" label="联系人" />
      <el-table-column prop="email" label="组织邮箱" />

      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="{row}">
          <div class="table-operator-wrapper">
            <span class="table-operator-btn edit-btn" @click="onOpenEditor(row)">
              <i class="el-icon-edit" aria-hidden="true"></i>
            </span>
            <span v-if="isAdmin" class="table-operator-btn delete-btn" @click.stop="onShowDeleteConfirmDialog(row)">
              <i class="el-icon-delete" aria-hidden="true"></i>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </template>

  <template #editor>
    <org-editor
      ref="editor"
      :org-types="orgTypes"
      :sites="sites"
      :site-devices="siteDevices"
      :list="list"
      @save="onOrgSave"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../BaseListEditor'
import OrgEditor from './OrgEditor'
import {ORG_SELECT_CHANGED} from './EventKeys'
import {mapGetters} from 'vuex'

export default {
  name: 'OrgListEdit',
  components: {OrgEditor},
  extends: BaseListEditor,
  data () {
    return {
      orgTypes: [],
      sites: [],
      siteDevices: []
    }
  },
  computed: {
    ...mapGetters({
      orgTypeId: 'Profile/orgTypeId'
    }),
    orgTypeMap () {
      return this.orgTypes.reduce((map, orgType) => {
        map[orgType.id] = orgType
        return map
      }, {})
    }
  },
  methods: {
    onSelectOrg (org) {
      this.selectOrg(org)
    },
    search () {
      this.clearSelectedList()
      this.getSites()
      this.getSiteDevices()
      this.getList()
    },
    selectOrg (org) {
      let {currentOrg} = this

      if (!currentOrg || currentOrg.id !== org.id) {
        this.currentOrg = org
        this.$eventBus.emit(ORG_SELECT_CHANGED, org)
      }

      this.$nextTick(() => {
        let table = this.getTable()

        if (table) {
          let id = org.id
          let tableData = table.tableData.find(org => org.id === id)
          table.setCurrentRow(tableData)
        }
      })
    },
    getSites () {
      this.$api.Site.getList().then(sites => {
        this.sites = Object.freeze(sites)
      }).catch(console.error)
    },
    getSiteDevices () {
      this.$api.SiteDevice.getList().then(siteDevices => {
        let {deviceMap} = this
        siteDevices.forEach(siteDevice => {
          let device = deviceMap[siteDevice.deviceId]
          siteDevice.name = device.name || `${device.brand}${device.model}`
        })
        this.siteDevices = Object.freeze(siteDevices)
      }).catch(console.error)
    },
    onOrgSave (org) {
      this.org = org
      this.getSites()
      this.getSiteDevices()
      this.getList()
    },
    afterQuery () {
      let {org} = this

      if (org) {
        this.selectOrg(org)
        this.org = null
      } else {
        let {list} = this
        this.selectOrg(list.length > 0 ? list[0] : {
          id: null
        })
      }
    }
  },
  watch: {
    devices: {
      immediate: true,
      handler (devices) {
        if (devices.length > 0) {
          this.getSites()
          this.getSiteDevices()
          this.getList()
        }
      }
    }
  },
  created () {
    this.$api.Org.getOrgTypes().then(orgTypes => {
      this.orgTypes = Object.freeze(orgTypes)
    }).catch(console.error)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/02Org/OrgListEdit.vue